import { TradingOffersListContextType } from '../types/TradingOffersListContextType';

export const tradingOffersListInitValue: TradingOffersListContextType = {
  data: {
    societyId: '',
    societyName: '',
    sellOffers: [],
    buyOffers: [],
    partnerOperations: [],
    sellOffersSummary: {
      offersCount: 0,
      sharesCount: 0,
      totalAmount: 0,
    },
    buyOffersSummary: {
      offersCount: 0,
      sharesCount: 0,
      totalAmount: 0,
    },
    activeOperationsCount: 0,
    totalOperationsCount: 0,
    sellOffersSortBy: 'price',
    buyOffersSortBy: 'price',
    isAdmin: false,
    isReadOnly: false,
    isLoading: true,
  },
  actions: {
    handleCreateSellOffer: () => {},
    handleCreateBuyOffer: () => {},
    handleViewOfferDetail: () => {},
    handleSellOffersSortChange: () => {},
    handleBuyOffersSortChange: () => {},
  },
};
